import { wsService } from "./wsService";
import UserType from "@/constants/user_type";
import { pushService } from "./pushService";

function login(email, password) {
  const param = {
    email: email,
    password: password,
  };
  return wsService.make_post_request("auth/login", param);
}

function isAuthenticated() {
  return localStorage.getItem("token") != undefined && localStorage.getItem("expire_in") != undefined && Math.floor(Date.now() / 1000) < localStorage.getItem("expire_in");
}

// param: { current_password, password, password_confirmation }
function change_password(param) {
  return wsService.make_post_request("auth/change-password", param);
}

// Primer ingreso con la contraseña temporal que puso RRHH
function mustChangePassword() {
  return localStorage.getItem("must_change_password") == "true";
}

// Solo el empleado: GenericMixin.isEmployee() tambien incluye al superusuario
function isEmployeeUser() {
  return localStorage.getItem("user_type") == UserType.EMPLOYEE;
}

function userInitials() {
  return (localStorage.getItem("name") || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join("");
}

function logOut() {
  // Un dispositivo compartido no puede seguir recibiendo los avisos del usuario que salio
  pushService.forgetDevice().catch((e) => console.log(e));
  //localStorage.removeItem("token");
  //localStorage.removeItem("expire_in");
  localStorage.clear();
}

export const authService = {
  login,
  isAuthenticated,
  logOut,
  change_password,
  mustChangePassword,
  isEmployeeUser,
  userInitials,
};
